import { BASE_URL } from '../constants'
import { token } from '../../localStorage/index'

export const deactivateUser = async ({ reason }) => {
  const rawBody = JSON.stringify({ reason })
  const URL = `${BASE_URL}v2/user/deactivation`

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const newRegisterCompany = async (data) => {
  const rawBody = JSON.stringify(data)
  const URL = `${BASE_URL}master/create/company/contract`

  const response = await fetch(URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: token?.token,
    },
    body: rawBody,
  })
  const res = await response.json()

  if (!response.ok) {
    throw new Error(res?.msg || 'No se pudo crear la empresa')
  }

  return {
    response,
    res,
  }
}

export const updateCompanyContract = async ({
  companyName,
  companyDisplayName,
  nif,
  sepa,
  zipCode,
  writtenAddress,
  country,
  state,
  city,
  phone,
  vat,
  website,
  legalContactName,
  legalContactDni,
}) => {
  const rawBody = JSON.stringify({
    companyName,
    companyDisplayName,
    nif,
    sepa,
    zipCode,
    writtenAddress,
    country,
    state,
    city,
    phone,
    vat,
    website,
    legalContactName,
    legalContactDni,
  })
  const URL = `${BASE_URL}master/update/company/contract`

  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const createInfoCompanyV2 = async (data) => {
  const rawBody = JSON.stringify(data)
  const URL = `${BASE_URL}v2/user/company`

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    }).then()
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getContractDocuments = async () => {
  const URL = `${BASE_URL}contract/document`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getContractDocumentById = async (id) => {
  const URL = `${BASE_URL}contract/document/one?id=${id}`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const createContractDocument = async ({
  file,
  name,
  taxes,
  amount,
  taxApplies,
  indefiniteTime,
  months,
  profileId,
}) => {
  const URL = `${BASE_URL}contract/document`
  const formData = new FormData()

  formData.append('file', file)
  formData.append('name', String(name))
  formData.append('taxes', String(taxes))
  formData.append('amount', String(amount))
  formData.append('taxApplies', taxApplies ? 'true' : 'false')
  formData.append('indefiniteTime', indefiniteTime ? 'true' : 'false')
  formData.append('months', String(months))
  formData.append('profileId', String(profileId))

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        authorization: token?.token,
      },
      body: formData,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const updateContractDocument = async ({
  id,
  name,
  content = '',
  taxes,
  amount,
  taxApplies,
  indefiniteTime,
  months,
}) => {
  const URL = `${BASE_URL}contract/document`
  const rawBody = JSON.stringify({
    id: Number(id),
    name,
    content,
    taxes: Number(taxes),
    amount: Number(amount),
    taxApplies: Boolean(taxApplies),
    indefiniteTime: Boolean(indefiniteTime),
    months: Number(months),
  })

  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const deleteContractDocument = async (id) => {
  const URL = `${BASE_URL}contract/document?id=${id}`

  try {
    const response = await fetch(URL, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const assignCompanyTalentContract = async ({
  name,
  companyId,
  talentId,
  contractTalentId,
  contractCompanyId,
  dateInit,
}) => {
  const rawBody = JSON.stringify({
    name,
    companyId,
    talentId,
    contractTalentId,
    contractCompanyId,
    dateInit,
  })
  const URL = `${BASE_URL}contract`

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getCompanyContracts = async (page = 0) => {
  const URL = `${BASE_URL}contract?page=${page}`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getCompanyTalentList = async () => {
  const URL = `${BASE_URL}contract/talentList`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const signCompanyContract = async (data) => {
  const rawBody = JSON.stringify(data)
  const URL = `${BASE_URL}contract/signing`

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const uploadCompanyInvoice = async ({ file, companyId }) => {
  const URL = `${BASE_URL}master/invoice`
  const formData = new FormData()

  formData.append('file', file)
  formData.append('statusId', 1)
  formData.append('companyId', String(companyId))


  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        authorization: token?.token,
      },
      body: formData,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const updateMasterInvoice = async ({ id, status, invoiceNumber, file }) => {
  const URL = `${BASE_URL}master/invoice`
  const formData = new FormData()

  formData.append('id', String(Number(id)))
  formData.append('status', String(Number(status)))

  if (invoiceNumber != null) {
    formData.append('invoiceNumber', String(invoiceNumber))
  }

  if (file) {
    formData.append('file', file)
  }

  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        authorization: token?.token,
      },
      body: formData,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getMasterInvoices = async (
  page = 0,
  { companyId, dateAfter, dateBefore } = {}
) => {
  const params = new URLSearchParams({ page })
  if (companyId) params.append('companyId', companyId)
  params.append('dateAfter', dateAfter)
  params.append('dateBefore', dateBefore)

  const URL = `${BASE_URL}master/invoice?${params.toString()}`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getCompanyInvoices = async (page = 0) => {
  const URL = `${BASE_URL}invoice?page=${page}`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getCompanyInvoiceById = async (id) => {
  const URL = `${BASE_URL}invoice/one?id=${id}`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const updateCompanyActive = async ({ companyId, active }) => {
  const URL = `${BASE_URL}master/company/active`
  const rawBody = JSON.stringify({
    companyId,
    active,
  })

  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const updateCompanyAssociated = async ({
  currentCompanyId,
  newCompanyId,
}) => {
  const URL = `${BASE_URL}master/company/associated`
  const rawBody = JSON.stringify({
    currentCompanyId,
    newCompanyId,
  })

  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const updateCompanyAssociatedOffer = async ({
  offerId,
  newCompanyId,
}) => {
  const URL = `${BASE_URL}master/company/associated/offer`
  const rawBody = JSON.stringify({
    offerId,
    newCompanyId,
  })

  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const initializeBootBulk = async ({
  talentId,
  offerId = null,
  promptQuestionId,
  templeteName = null,
}) => {
  const URL = `${BASE_URL}whatsapp/initializeBootBulk`
  const rawBody = JSON.stringify({
    talentId,
    offerId,
    promptQuestionId,
    templeteName,
  })

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const initializeChatBulk = async ({ talentId, templeteName = null }) => {
  const URL = `${BASE_URL}whatsapp/initializeChatBulk`
  const rawBody = JSON.stringify({
    talentId,
    templeteName,
  })

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getMetaTemplates = async () => {
  const URL = `${BASE_URL}whatsapp/metaTemplates`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const acceptCompanyInvoice = async ({ id, status = true }) => {
  const URL = `${BASE_URL}invoice/accept`
  const rawBody = JSON.stringify({
    id: Number(id),
    status: Boolean(status),
  })

  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}